import { Pipe, PipeTransform } from '@angular/core';
import { IStatus } from 'app/models/licenses/status';

@Pipe({
  name: 'filterApproved'
})
export class FilterApprovedPipe implements PipeTransform {

  transform(items: IStatus[]): any[] {
    return items.filter(item => item.label !== 'Approved');
  }
}
